import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b719b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "status-overlay"
}
const _hoisted_2 = { class: "status-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status-msg" }, "正在回测中...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status-sub" }, "请点击下面按钮进行刷新", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("刷新")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status-msg" }, "回测失败", -1))
const _hoisted_7 = { class: "status-countdown" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status-msg" }, "策略/回测未找到", -1))
const _hoisted_9 = { class: "status-countdown" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status-msg" }, "策略失效", -1))
const _hoisted_11 = { class: "status-countdown" }

import { ref, watch, onUnmounted } from 'vue'
import { useStarRouter } from '@/utils/useStarTheme'


export default /*#__PURE__*/_defineComponent({
  __name: 'BacktestStatusOverlay',
  props: {
    status: null
  },
  emits: ["refresh"],
  setup(__props: any, { emit }: { emit: ({ (e: 'refresh'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { status: number }




const { starPush } = useStarRouter()
const goHome = () => starPush('/star')

const inner = ref(3)
let timer: ReturnType<typeof setInterval> | null = null

const startCountdown = () => {
    inner.value = 3
    if (timer) clearInterval(timer)
    timer = setInterval(() => {
        inner.value--
        if (inner.value <= 0) {
            clearInterval(timer!)
            goHome()
        }
    }, 1000)
}

watch(() => props.status, (val) => {
    if (val === 3 || val === 4 || val === 5) startCountdown()
    else if (timer) { clearInterval(timer); timer = null }
}, { immediate: true })

onUnmounted(() => { if (timer) clearInterval(timer) })

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (__props.status !== 2)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.status === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _hoisted_4,
                _createVNode(_component_a_button, {
                  class: "status-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ], 64))
            : (__props.status === 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_6,
                  _createElementVNode("p", _hoisted_7, _toDisplayString(inner.value) + " 秒后返回首页", 1)
                ], 64))
              : (__props.status === 4)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_8,
                    _createElementVNode("p", _hoisted_9, _toDisplayString(inner.value) + " 秒后返回首页", 1)
                  ], 64))
                : (__props.status === 5)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _hoisted_10,
                      _createElementVNode("p", _hoisted_11, _toDisplayString(inner.value) + " 秒后返回首页", 1)
                    ], 64))
                  : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})